var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import { traitClass } from "../Trait";
import CatalogMemberReferenceTraits from "./CatalogMemberReferenceTraits";
let CatalogIndexReferenceTraits = (_dec = traitClass({
  description: "See [CatalogIndex](/guide/customizing/search-providers/#catalogindex) guide. \n\nIf your TerriaMap has many dynamic groups which need to be loaded, it may be worth generating a static catalog index JSON file.\n\n- `yarn build-tools`\n- `node ./build/generateCatalogIndex.js -c config-url -b base-url`"
}), _dec2 = primitiveArrayTrait({
  type: "string",
  name: "Member known container unique IDs",
  description: "These are used to load models which this model depends on (eg parent groups)."
}), _dec3 = primitiveArrayTrait({
  type: "string",
  name: "Share keys",
  description: "Share keys can be used to resolve older model IDs to this model."
}), _dec4 = primitiveTrait({
  name: "Name in catalog",
  description: "The name of the item to be displayed in the catalog. This will only be defined if it differs from `name`.",
  type: "string"
}), _dec(_class = (_class2 = class CatalogIndexReferenceTraits extends mixTraits(CatalogMemberReferenceTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "memberKnownContainerUniqueIds", _descriptor, this);
    _initializerDefineProperty(this, "shareKeys", _descriptor2, this);
    _initializerDefineProperty(this, "nameInCatalog", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "memberKnownContainerUniqueIds", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "shareKeys", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "nameInCatalog", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { CatalogIndexReferenceTraits as default };